<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="data_local.avatar" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data_local.nom  }}</p>
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button class="mr-4 mb-4" @click="$refs.updateImgInput.click()">Changer d'avatar</vs-button>
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <vs-button type="border" color="danger" @click="data_local.avatar = null">Supprimer</vs-button>
          </div>
        </div>
      </div>
    </div>
     

          

          
        
          
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Username" v-model="data_local.nom" v-validate="'required|alpha_num'" name="username" />
        <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>

        <vs-input class="w-full mt-4" label="Name" v-model="data_local.prenom" v-validate="'required|alpha_spaces'" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
        
        
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <!-- domaine-->
        <div class="mt-4">
        <label class="mt-0 vs-input--label">Domaine</label>
          <v-select class=" w-full" v-model="domaine_local" :clearable="false" :options="domaine_choices" v-validate="'required'" name="domain" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('domaine')">{{ errors.first('domaine') }}</span>
        </div>
        <!-- grade-->
        <div class="mt-4">
        <label class="mt-0 vs-input--label">Grade</label>
          <v-select class=" w-full" v-model="grade_local" :clearable="false" :options="grade_choices" v-validate="'required'" name="grade" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('grade')">{{ errors.first('grade') }}</span>
        </div>
        </div>
    </div>

    <!-- Permissions -->
    <!--vx-card class="mt-base" no-shadow card-border>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Permissions</span>
          </div>
          <vs-divider />
        </div>
      </div>

      <div class="block overflow-x-auto">
        <table class="w-full">
          <tr-->
            <!--
              You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
              our data structure. You just have to loop over above variable to get table headers.
              Below we made it simple. So, everyone can understand.
             -->
            <!--th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Module', 'Read', 'Write', 'Create', 'Delete']" :key="heading">{{ heading }}</th>
          </tr>

          <tr v-for="(val, name) in data_local.permissions" :key="name">
            <td class="px-3 py-2">{{ name }}</td>
            <td v-for="(permission, name) in val" class="px-3 py-2" :key="name+permission">
              <vs-checkbox v-model="val[name]" />
            </td>
          </tr>
        </table>
      </div>

    </vx-card-->

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Sauvegarder</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Réinitialiser</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import moduleformateur from '@/store/formateur/moduleformateur.js'
import moduledomaine from '@/store/domaine/moduledomaine.js'
//import axios from "../../../../http/axios/index.js"
//import users from "../../../../fake-db/data/user-management/index.js"
export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      data_local: JSON.parse(JSON.stringify(this.data[0])),
      
    
      domaineOptions: [],
      change_image: false,
      grade_choices: [
        { label: 'Professeur', value: 'Professeur' },
        { label: 'Maître de conférences', value: 'Maître de conférences' },
        { label: 'Maître assistant', value: 'Maître assistant' },
        { label: 'Assistant', value: 'Assistant' },
        { label: 'Professeur technologue', value: 'Professeur technologue' },
        { label: 'Maître technologue', value: 'Maître technologue' },
        { label: 'Technologue', value: 'Technologue' },
        { label: 'Assistant technologue', value: 'Assistant technologue' },
      ],
    }
  },
  computed: {
    domaine_choices() {
        let opts=[];
          for (var domaine  of this.$store.state.domaine.users) {
              opts.push({label: domaine.nom_domaine, value: domaine.id});
            }
      console.log("c",this.$store.state.domaine.users)     
      return opts
    },
    domaine_local: {
      get() {
        return { label: this.data_local.nom_domaine,  value: this.data_local.id  }
      },
      set(obj) {
        this.data_local.nom_domaine = obj.label
        this.data_local.domaine_id = obj.value
      }
    },
    grade_local: {
      get() {
        return { label: this.data_local.grade,  value: this.data_local.grade  }
      },
      set(obj) {
        this.data_local.grade = obj.value
        console.log(this.data_local.grade) 
      }
    },
    
   /* status_local: {
      get() {
        console.log(this.data)
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set(obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get() {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set(obj) {
        this.data_local.role = obj.value
      }
    },*/
    
    validateForm() {
      return !this.errors.any()
    }
  },
  created() {
    // Register Module UserManagement Module
    if(!moduleformateur.isRegistered) {
      this.$store.registerModule('formateur', moduleformateur)
      moduleformateur.isRegistered = true
    }
    this.$store.dispatch("formateur/fetchUsers").catch(err => { console.error(err) })
  console.log('this.data_local',this.data_local)

    if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
   this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })
    },
  methods: {
    capitalize(str) {
      return str.slice(0,1).toUpperCase() + str.slice(1,str.length)
    },
    
    save_changes() {
      
      
       
       this.$store.dispatch("formateur/updateRecord", this.data_local).then(()   => { this.$store.dispatch("formateur/fetchUsers").catch(err => { console.error(err) }); this.$forceUpdate(); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('success', 'mise à jour', 'mise à jour réussie') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not update', 'an error in update: '+ err) }) 
       if(this.change_image){
       this.$store.dispatch("formateur/updateavatarRecord", this.data_local).then(()   => { this.$store.dispatch("formateur/fetchUsers").catch(err => { console.error(err) }); this.$forceUpdate(); this.activeLoading = false; this.$vs.loading.close();  }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not update', 'an error in update: '+ err) }) 
       console.log("avatar change")
       }
      
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'Formateur '+title,
                text: 'Formateur : '+text
              })
            },
    reset_data() {
      
      this.data_local = JSON.parse(JSON.stringify(this.data[0]))
      
    },
    update_avatar() {
//
    },
    updateCurrImg(input) {
      
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.data_local.avatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
      this.change_image = true
      console.log("this.change_image",this.change_image)

    }
  },
}
</script>